import React from "react";
import LandingPageThemeSettingPanelComponent from "./landingPageThemeSettingPanel.component";
import { getConsumerPageSetting, setThemeSetting } from "../../../redux";
import { selectLoading } from "modules/notification";
import { connect, useSelector } from "react-redux";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import {AccessRights} from "lib/constants/accessRights";
import { useDispatch } from "react-redux"
import {canAccess} from "../../../../profile/redux/selector/profile.selector";

function LandingPageThemeSettingPanelContainer({ settings, isFetching, }) {
  const dispatch = useDispatch()
  const hasCompanyProductEditAccessRight = useSelector(state =>
    canAccess(state, AccessRights.Company.PRODUCT_PAGE_WRITE));

  const theme = useTheme();
  const mdWidth = useMediaQuery(theme.breakpoints.down("md"));
  const lang = useSelector(state => state.constant.languages)

  const handleChange = (name, value ) => {
    dispatch(setThemeSetting({ name: name, value: value }))
  }

  return (
    <LandingPageThemeSettingPanelComponent
      hasCompanyEditAccessRight={hasCompanyProductEditAccessRight}
      settings={settings}
      isFetching={isFetching}
      mdWidth={mdWidth}
      handleChange={handleChange}
      lang={lang}
    />
  );
}

const mapStateToProps = (state) => ({
  settings: state.setting,
  isFetching: selectLoading(state, getConsumerPageSetting.typePrefix),
});


export default connect(
  mapStateToProps,
  null
)(LandingPageThemeSettingPanelContainer);
